import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ExamReportService } from 'src/app/exam-layout/operations/exam-report.service';
import { ExamScriptReportComponent } from 'src/app/examschedule-layout/exam-script-report/exam-script-report.component';
import { ExamScheduleOperationsService } from 'src/app/services/exam-schedule-operations.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DetailsMenuComponent } from '../details-menu/details-menu.component';
import { PopoverRef } from '../popover/popover-ref';
import { OperationStatus } from 'src/app/exam-layout/operationstatus';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';

@Component({
  selector: 'app-reports-menu',
  templateUrl: './reports-menu.component.html',
  styleUrls: ['./reports-menu.component.scss']
})
export class ReportsMenuComponent implements OnInit {
  reports = [];
  currentRoute = "";
  enableOps = false
  constructor(private popoverRef: PopoverRef<ReportsMenuComponent>, private route: Router,
    private examReport: ExamReportService, private examService: ExamService,
    private snackBar: SnackbarService, private exSchOps: ExamScheduleOperationsService, public operationStatus: OperationStatus,
    private examSchService: ExamScheduleService) {

  }

  ngOnInit() {
    this.currentRoute = '' + this.route.routerState.snapshot.url.split('?')[0];
    //when route changes needs to be updated
    this.route.events.subscribe((e) => {
      this.currentRoute = '' + this.route.routerState.snapshot.url.split('?')[0];
      if (this.currentRoute == '/exams') {
        this.reports = this.examReport.examReportList();
      } else if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)
        || this.currentRoute.includes(`/exams/${this.examService.selectedExamIds}/schedules/${this.examSchService.selectedIds}`)) {
        this.reports = this.examScheduleReportMenu;
      }
    });

    if (this.currentRoute == '/exams') {
      this.reports = this.examReport.examReportList();
    }
    else if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)
      || this.currentRoute.includes(`/exams/${this.examService.selectedExamIds}/schedules/${this.examSchService.selectedIds}`)) {
      this.reports = this.examScheduleReportMenu;
    }
    console.log(this.currentRoute);

  }


  examScheduleReportMenu = [
    // {
    //   icon: 'mat:description',
    //   label: 'Export Examination Script',
    //   route: 'report/schedule/script',
    //   id: 'examinationschedules_examination_script'
    // },
    {
      icon: 'mat:assignment',
      label: 'Examination Script',
      route: `report/schedule/view-script`,
      id: 'view_examination_script'
    },
    {
      icon: 'mat:assignment',
      label: 'Psychometric Report',
      route: `report/schedule/psychometric-report`,
      id:'examination_psychometric_report'
    },
  ]


  close(setIe: any) {
    console.log(setIe);
    this.popoverRef.close();
  }
  async processOp(route: any, origin: any) {
    //console.log(route);
    if (route.includes("exam")) {
      if (this.examService.selectedExams?.length > 1) {
        this.snackBar.warning('Multiple Examinations Selected');
        return;
      }
      this.examReport.processExamReport(route, origin);
    }
    if (route.includes("report/schedule")) {
      if (route === "report/schedule/script") {
        this.exSchOps.openPopup(origin, ExamScriptReportComponent)
      } else {
        const normalizedUrl = this.currentRoute.replace(/\?examNo=\d+/, '');
        this.route.navigate([`${normalizedUrl}/${route}`]);
      }
    }

    if (route.includes('psychometric-report')) {
      const examId = this.examService.selectedExamIds?.[0];
      const scheduleId = this.examSchService.selectedIds?.[0];
      
      if (examId && scheduleId) {
        this.route.navigate([
          'exams',
          examId,
          'schedules',
          'report',
          scheduleId,
          'psychometric-report'
        ]);
      }

    this.popoverRef.close();
  } 
 }
}
